import React, { useEffect, useState } from "react";
import { FormattedMessage } from "react-intl";
import classNames from "classnames";

type UnfocusedProgressProps = {
  isVisible: boolean;
  onButtonClick: () => void;
};

function UnfocusedProgressOverlay({
  isVisible,
  onButtonClick,
}: UnfocusedProgressProps) {
  const [isButtonVisible, setIsButtonVisible] = useState<boolean>(false);

  useEffect(() => {
    if (!isVisible) {
      setIsButtonVisible(false);
    }
    const timeout = setTimeout(() => {
      setIsButtonVisible(isVisible);
    }, 300);
    return () => {
      clearTimeout(timeout);
    };
  }, [isVisible]);

  return (
    <div
      className={classNames(
        "absolute top-0 left-0 bottom-0 right-0 z-30 flex items-center justify-center",
        {
          hidden: !isButtonVisible,
        },
      )}
    >
      <button
        onClick={() => {
          setIsButtonVisible(false);
          onButtonClick();
        }}
        type='button'
        className='btn btn-primary'
      >
        <FormattedMessage id='continue-typing' />
      </button>
    </div>
  );
}

export default UnfocusedProgressOverlay;
